import type { FileWithPath } from '@mantine/dropzone';

import { useMutation } from '@tanstack/react-query';

import { createBuyerSimProposalVersion } from '../../../../../../../../shared/api/magellan/BuyerSimulationBidResponses';
import { BuyerSimResponseDocType } from '../../../../../../../../shared/entities/BuyerSimBidResponse';

type CreateBuyerSimProposalVersionRequestDto = {
  buyerSimBidResponseId: number;
  proposalFiles: FileWithPath[];
  complementaryFiles: FileWithPath[];
  onSuccessCallback?: (data: any) => void;
};

export const useCreateBuyerSimProposalVersion = () => {
  const createMutation = useMutation({
    mutationFn: async ({
      buyerSimBidResponseId,
      proposalFiles,
      complementaryFiles,
    }: CreateBuyerSimProposalVersionRequestDto) => {
      const formData = new FormData();

      proposalFiles.forEach(file => {
        formData.append(
          BuyerSimResponseDocType.PROPOSAL_TECHNICAL_SUBMISSION,
          file,
          encodeURIComponent(file.name),
        );
      });
      complementaryFiles.forEach(file => {
        formData.append(
          BuyerSimResponseDocType.PROPOSAL_APPENDICES,
          file,
          encodeURIComponent(file.name),
        );
      });

      const res = await createBuyerSimProposalVersion(
        buyerSimBidResponseId,
        formData,
      );
      return res;
    },
    onSuccess: (data, { onSuccessCallback }) => {
      onSuccessCallback && onSuccessCallback(data);
    },
  });

  return {
    createBuyerSimProposalVersion: createMutation.mutate,
  };
};
